module.exports = __webpack_public_path__ + "8d8f7a8f62c05e451073f84a224272be.svg";